import React from "react";
import moment from "moment";
import { RenderNumberPercentage } from "../../../../../../Utils/renderField/renderReadField";

// titulo es opcional: el detalle de un turno ya cerrado lo deja en su valor
// por defecto y el listado de tancadas lo cambia cuando el turno sigue en curso.
// drcPadresPT también: el listado de tancadas muestra el DRC del turno de cada
// padre PT con cargas, y el detalle lo muestra en la tabla de padres PT
export const DatosTurnoDetalle = ({
    turno = {},
    drcPadresPT = [],
    titulo = "Turno finalizado",
}) => {
    return (
        <div>
            <h5 className="mb-3 text-center">{titulo}</h5>
            <div className="formulario-fields-row gap-1rem mt-2 mb-3 flex-wrap">
                <div className="formulario-field min-w-150">
                    <label className="text-nowrap">
                        {turno && turno.supervisores
                            ? "Supervisores"
                            : "Supervisor"}
                    </label>
                    <input
                        type="text"
                        className="form-control"
                        disabled
                        value={turno.supervisores || ""}
                    />
                </div>

                <div className="formulario-field min-w-150">
                    <label className="text-nowrap">Op. báscula</label>
                    <input
                        type="text"
                        className="form-control"
                        disabled
                        value={turno.operador_bascula || ""}
                    />
                </div>

                <div className="formulario-field min-w-150">
                    <label className="text-nowrap">Op. montacargas</label>
                    <input
                        type="text"
                        className="form-control"
                        disabled
                        value={turno.operador_montacargas || ""}
                    />
                </div>

                <div className="formulario-field min-w-150">
                    <label className="text-nowrap">Turno</label>
                    <input
                        type="text"
                        className="form-control"
                        disabled
                        value={turno.turno_display || ""}
                    />
                </div>

                <div className="d-flex gap-1rem flex-1">
                    <div className="formulario-field min-w-150">
                        <label className="text-nowrap">Fecha inicio</label>
                        <input
                            type="text"
                            className="form-control"
                            disabled
                            value={
                                turno.fecha_inicial
                                    ? moment(turno.fecha_inicial).format(
                                          "DD/MM/YYYY HH:mm",
                                      )
                                    : ""
                            }
                        />
                    </div>

                    <div className="formulario-field min-w-150">
                        <label className="text-nowrap">Fecha fin</label>
                        <input
                            type="text"
                            className="form-control"
                            disabled
                            value={
                                turno.fecha_final
                                    ? moment(turno.fecha_final).format(
                                          "DD/MM/YYYY HH:mm",
                                      )
                                    : ""
                            }
                        />
                    </div>
                </div>
            </div>
            {drcPadresPT.length > 0 && (
                <div className="formulario-fields-row gap-1rem mb-3 flex-wrap justify-content-start">
                    {drcPadresPT.map((item) => (
                        <div
                            key={item.padre_producto_terminado_id}
                            className="formulario-field horizontal"
                            style={{ maxWidth: "220px" }}
                        >
                            <label className="text-nowrap">
                                DRC {item.padre_producto_terminado_nombre}
                            </label>
                            {item.drc_turno ? (
                                <RenderNumberPercentage
                                    className="form-control disabled-input"
                                    value={item.drc_turno}
                                    decimals={2}
                                />
                            ) : (
                                <input
                                    type="text"
                                    className="form-control"
                                    disabled
                                    value="Pendiente"
                                />
                            )}
                        </div>
                    ))}
                </div>
            )}
        </div>
    );
};
